import { Component, Input, Output, EventEmitter, inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { OwnerType } from '../../../../core/models/announcement.model';

@Component({
  selector: 'app-contact-card',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="contact-card">
      <div class="owner-info">
        <div class="avatar">
          <i class="fas fa-user"></i>
        </div>
        <div class="details">
          <h3 class="name">{{ contactName }}</h3>
          <span class="type" [class.agent]="ownerType === ownerTypes.Agent">{{ ownerType === ownerTypes.Agent ? 'Vasitəçi' : 'Mülkiyyətçi' }}</span>
        </div>
      </div>

      <div class="phone-section">
        <div class="phone-display" *ngIf="isPhoneVisible">
          <a [href]="'tel:' + contactPhone" class="phone-link">{{ contactPhone }}</a>
        </div>
        <button class="cta-button" (click)="togglePhone()">
          <i class="fas fa-phone-alt"></i>
          {{ isPhoneVisible ? 'Zəng et' : 'Nömrəni göstər' }}
        </button>
      </div>

      <button class="vip-button" *ngIf="isOwner" (click)="onVipClick.emit()">
        <i class="fas fa-crown"></i>
        VIP et
      </button>
    </div>
  `,
  styles: [`
    .contact-card {
      background: #fff;
      border: 1px solid #f1f2f6;
      border-radius: 12px;
      padding: 24px;
      display: flex;
      flex-direction: column;
      gap: 20px;
      box-shadow: 0 4px 20px rgba(0,0,0,0.05);
      position: sticky;
      top: 24px;
    }
    .owner-info {
      display: flex;
      align-items: center;
      gap: 16px;
    }
    .avatar {
      width: 56px;
      height: 56px;
      background: #f1f2f6;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      color: #b2bec3;
    }
    .name {
      font-size: 18px;
      font-weight: 700;
      margin: 0;
      color: #2d3436;
    }
    .type {
      font-size: 14px;
      color: var(--primary-color);
      font-weight: 600;
    }
    .type.agent {
      color: #e74c3c;
    }
    .phone-section {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }
    .phone-display {
      text-align: center;
      font-size: 20px;
      font-weight: 700;
      color: #007bff;
    }
    .phone-link {
      color: inherit;
      text-decoration: none;
    }
    .cta-button {
      background: #00b894;
      color: white;
      border: none;
      padding: 14px;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      transition: background 0.2s;
    }
    .cta-button:hover { background: #00a383; }
    .vip-button {
      background: #6c5ce7;
      color: white;
      border: none;
      padding: 12px;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      transition: background 0.2s;
    }
    .vip-button:hover { background: #5b4cc4; }
  `]
})
export class ContactCardComponent {
  private platformId = inject(PLATFORM_ID);
  @Input() contactName!: string;
  @Input() contactPhone!: string;
  @Input() ownerType!: OwnerType;
  @Input() isOwner: boolean = false;
  @Output() onVipClick = new EventEmitter<void>();

  ownerTypes = OwnerType;
  isPhoneVisible = false;

  togglePhone() {
    if (isPlatformBrowser(this.platformId)) {
      if (window.innerWidth < 768) {
        window.location.href = `tel:${this.contactPhone}`;
      } else {
        this.isPhoneVisible = true;
      }
    } else {
      // Server side, just make it visible if needed, but usually not applicable
      this.isPhoneVisible = true;
    }
  }
}
